import React from 'react';

import SmartLink from './SmartLink';

const ACFLink = props => {
    const data = props.data;

    if(!data.title) return '';

    return (
        <SmartLink to={data.url} className={props.className} target={data.target}>{data.title}</SmartLink>
    )
}

export default ACFLink;



// WEBPACK FOOTER //
// ./src/partials/ACFLink.js